import { Component, ElementRef, Input } from '@angular/core';
import { HorizontalPositionOption } from '../../../common/models';
import { Router } from '@angular/router';


@Component({
    selector: 'lib-button-widget',
    templateUrl: './button-widget.component.html',
    styleUrls: ['./button-widget.component.scss'],
    standalone: false
})
export class ButtonWidgetComponent {
  @Input() public buttonPosition: HorizontalPositionOption;
  @Input() public buttonText: string;
  @Input() public buttonLink: string;

  @Input() public set buttonColor(value: string) {
    this.element.nativeElement.style.setProperty('--lms-button-widget-color', value);
  }

  @Input() public set buttonTextColor(value: string) {
    this.element.nativeElement.style.setProperty('--lms-button-widget-text-color', value);
  }

  @Input() public set buttonBlur(value: string) {
    this.element.nativeElement.style.setProperty('--lms-button-widget-blur', value);
  }

  constructor(
    private readonly router: Router,
    private readonly element: ElementRef) { }

  public handleLinkClick(): void {
    if (!this.buttonLink) {
      return;
    }

    const isExternalLink = /^https?:\/\//i.test(this.buttonLink);

    if (isExternalLink) {
      window.open(this.buttonLink);
      return;
    }

    this.router.navigateByUrl(this.buttonLink);
  }
}
